import { formatDateToMMDDYYYY } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { IconButton } from 'react-native-paper';
import { Colors } from '../../themes';

type CreatedDateFieldProps = {
  createdAt: string;
  adjustCreationDate?: string;
};

export const CreatedDateField = ({ createdAt, adjustCreationDate }: CreatedDateFieldProps) => {
  const { t } = useTranslation();

  // Always show the original createdAt, not the effective creation date
  const formattedDate = createdAt ? formatDateToMMDDYYYY(createdAt) : '';

  return (
    <>
      <View>
        <Text style={styles.formItemTitle}>
          {t('issue.createdDate.header')}
        </Text>
      </View>
      <View style={styles.datePickerContainer}>
        <View style={styles.dateDisplayContainer}>
          <Text style={styles.dateText}>{formattedDate}</Text>
        </View>
        <IconButton
          icon="calendar-month"
          size={16}
          iconColor={Colors.grayText}
          style={styles.calendarIconStyle}
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  formItemTitle: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 16,
    marginBottom: 16,
  },
  datePickerContainer: {
    borderWidth: 1,
    borderColor: Colors.grayText,
    height: 52,
    flex: 1,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 4,
    paddingLeft: 12,
    marginTop: 8,
    backgroundColor: Colors.primaryGrayBackground,
    ...(Platform.OS === 'web' && {
      maxHeight: 52,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
      height: 52,
      minHeight: 52,
      overflow: 'visible',
      paddingVertical: 0,
      position: 'relative',      
    }),
  },
  dateDisplayContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  dateText: {
    fontSize: 16,
    fontWeight: '400',
    color: Colors.grayText,
  },
  calendarIconStyle: {
    margin: 0,
    padding: 0,
    ...(Platform.OS === 'web' && {
      alignSelf: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
  },
});
